module.exports = __webpack_public_path__ + "static/hero-image-e3c628dc5fafa2b74426a360b32e1b3c.svg";